export default {
    los: function(e) {
      var html = '';
      html+='<div class="warnBox">\
        <div class="contv">'+e+'</div>\
      </div>';
      console.log(app);
    }
  }


// WEBPACK FOOTER //
// ./src/assets/js/web.js